export const SEARCH = {
  STORE: 'STORE_SEARCH',
  STORE_FIELD: 'STORE_SEARCH_FIELD',
  CLEAR: 'CLEAR_SEARCH',
  SET_LAST_PAGE: 'SET_LAST_PAGE'
}
